import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

interface IPlace {
    id: string,
    locatie: string,
}

@Injectable({
    providedIn: 'root'
})
export class MapsService {

    private basePath = environment.interop.basePath;

    private findPlacesURL = this.basePath + environment.interop.monitoring.maps.searchPlaces;
    private getPlaceDataURL = this.basePath + environment.interop.monitoring.maps.getPlaceData;

    constructor(private http: HttpClient) { }

    findPlaces(data: { input: string }) {
        return this.http
            .post<{ errors: boolean; data: IPlace[]; status_code: number }>(
                this.findPlacesURL, data
            )
    }

    getPlaceData(id: string) {
        return this.http
            .get<{ errors: boolean; data: any; status_code: number }>(
                this.getPlaceDataURL + id
            )
    }
}
